module.exports = __webpack_public_path__ + "img/plus-square.5af824a2.svg";